/* this is a js file because of conflicts*/
import React, { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router";
import Layout from "./components/Layout";
import Main from "./components/main";
import Games from "./components/games";
import Game from "./components/game";
import Play from "./components/play";
import PlayGame from "./components/playgame"; //OLD GQL Style
import Result from "./components/result";
import JoinGame from "./components/joingame";
import UI from "./components/ui";
import { AnimatePresence } from "framer-motion";

import "./App.css";
import "./App.scss";

function App() {
  // we could optionally get changeName func below too
  const location = useLocation();

  return (
    <Layout>
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.pathname}>
          <Route exact path="/" component={Main} />
          <Route exact path="/ui" component={UI} />
          <Route path="/game/:id" component={Game} />
          <Route path="/play/:id" component={Play} />
          <Route path="/playgame/:id" component={PlayGame} />

          <Route
            exact
            path={["/result/:id", "/result/:id/player/:player_id"]}
            component={Result}
          />
          <Route path="/games" component={Games} />
          <Route path="/join/:id" component={JoinGame} />
          <Route path="*">
            <HardRedirect to="/" />
          </Route>
        </Switch>
      </AnimatePresence>
    </Layout>
  );
}
const HardRedirect = (props: { to: string }) => {
  window.location.replace(
    `${window.location.protocol}//${window.location.host}${props.to}`
  );
  return null;
};

export default App;
